import { useEffect, useState } from 'react';
import axios from 'axios';
import { CalendarDays, Clock, Loader2, Lock } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const formatHour = (h) => {
  const suffix = h >= 12 ? 'PM' : 'AM';
  const display = h > 12 ? h - 12 : h === 0 ? 12 : h;
  return `${display} ${suffix}`;
};

const SlotPicker = ({
  date,
  onDateChange,
  serviceType,
  selectedHour,
  onSelectHour,
  accentClass = 'slot-accent-dm',
  testIdPrefix = 'slot',
}) => {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const today = new Date().toISOString().split('T')[0];

  useEffect(() => {
    if (!date) { setSlots([]); return; }
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API}/appointments/availability`, {
          params: { date, service_type: serviceType },
        });
        if (!cancelled) setSlots(res.data.slots || []);
      } catch {
        if (!cancelled) setSlots([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [date, serviceType]);

  return (
    <div className="slot-picker" data-testid={`${testIdPrefix}-picker`}>
      <div className="slot-date-row">
        <label className="slot-date-label">
          <CalendarDays size={16} /> Pick a date
        </label>
        <input
          type="date"
          className="slot-date-input"
          min={today}
          value={date}
          onChange={(e) => { onDateChange(e.target.value); onSelectHour(null); }}
          data-testid={`${testIdPrefix}-date-input`}
        />
      </div>

      {date && (
        <div className="slot-hours-wrap">
          <div className="slot-hours-label"><Clock size={14} /> Pick an hour</div>
          {loading ? (
            <div className="slot-loading"><Loader2 size={18} className="dm-spin" /> Loading slots...</div>
          ) : slots.length === 0 ? (
            <div className="slot-empty">No slots available. Try another date.</div>
          ) : (
            <div className="slot-grid" data-testid={`${testIdPrefix}-grid`}>
              {slots.map((s) => {
                const disabled = !s.available;
                const isSelected = selectedHour === s.hour;
                return (
                  <button
                    type="button"
                    key={s.hour}
                    disabled={disabled}
                    onClick={() => onSelectHour(s.hour)}
                    className={`slot-pill ${accentClass} ${isSelected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
                    data-testid={`${testIdPrefix}-hour-${s.hour}`}
                  >
                    <span className="slot-pill-time">{formatHour(s.hour)}</span>
                    <span className="slot-pill-status">
                      {s.is_open ? (s.available ? 'Available' : 'Full') : (<><Lock size={10} /> Closed</>)}
                    </span>
                  </button>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SlotPicker;
